/**
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business Spec Console フロントエンドのエントリポイント。Faro と i18n を初期化して React アプリをマウントする。
 * @graph-connects none
 */
import { initializeFaro } from '@cortex/faro';
initializeFaro({ appName: 'spec-console' });

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.js';
import './i18n/index.js';
import './styles.css';

/** @graph-connects none */
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
